import React, { Fragment, FC } from 'react';

import theme from '@adsk/alloy-react-theme';

import Line from './Line';
import { Collection, License } from '../helpers/types';

type AutomaticAboutBoxContentProps = {
  collections: Collection[];
};

const AutomaticAboutBoxContent: FC<AutomaticAboutBoxContentProps> = ({
  collections,
}) => {
  return (
    <>
      {collections?.map((collection: Collection) => (
        <Fragment key={collection.type}>
          <Line style={{ ...theme.typography.heading4, marginTop: 20 }}>
            The following components are licensed under {collection.type}{' '}
            license:
          </Line>
          {collection.licenses.map((license: License, i) => {
            let author;

            if (typeof license.author === 'string') {
              author = license.author;
            } else if (typeof license.author === 'object') {
              author = license.author.name;
            } else {
              author = license.repository;
            }

            return (
              <div key={license.name + i}>
                <Line style={theme.typography.labelMedium}>{license.name}</Line>
                <Line style={{ ...theme.typography.labelSmall, marginTop: 0 }}>
                  Copyright {author}
                </Line>
                {!collection.attribution && <Line>{license.licenseText}</Line>}
              </div>
            );
          })}
          {collection.attribution && <Line>{collection.attribution}</Line>}
        </Fragment>
      ))}
    </>
  );
};

export default AutomaticAboutBoxContent;
